// Attendre que le chargement de la page soit terminé
document.addEventListener('DOMContentLoaded', function() {
    // Sélectionner tous les liens dans les deux sélecteurs
    const links = document.querySelectorAll('.cc-slideshow + .shopify-section.cc-rich-text a, .cc-custom-liquid + .shopify-section.cc-rich-text a,.cc-collection-products +.shopify-section.cc-rich-text a, .cc-collection-list + .shopify-section.cc-rich-text a');
    
    // Ajouter un event listener à chaque lien
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault(); // Empêcher le comportement par défaut du lien
            
            // Trouver l'élément parent (soit .cc-slideshow soit .cc-custom-liquid + .shopify-section.cc-rich-text)
            const targetElement = this.closest('.cc-slideshow + .shopify-section.cc-rich-text') || 
                                  this.closest('.cc-custom-liquid + .shopify-section.cc-rich-text') || 
                                  this.closest('.cc-collection-products + .shopify-section.cc-rich-text') ||
                                  this.closest('.cc-collection-list + .shopify-section.cc-rich-text');
            
            // Toggle la classe 'afficher'
            if (targetElement) {
                targetElement.classList.toggle('afficher');
            }
        });
    });
    const ignored = [
        '#collection-ev10-rivalites-destinees',
        '#collection-ev10-5-foudre-noire', 
        '#collection-ev10-5-flamme-blanche',
        '#collection-ev09-aventures-ensemble',
        '#collection-ev08-etincelles-deferlantes',
        '#collection-ev08-5-evolutions-prismatiques',
        '#collection-ev07-couronne-stellaire',
        '#collection-ev06-mascarade-crepusculaire',
        '#collection-ev06-5-fable-nebuleuse-sfa',
        '#collection-ev05-forces-temporelles',
        '#collection-ev04-5-destinees-de-paldea',
        '#collection-ev03-flammes-obsidiennes',
        '#collection-ev03-5-ecarlate-et-violet-151-mew',
        '#collection-ev02-evolutions-a-paldea',
        '#collection-ev01-ecarlate-et-violet',
        '#collection-sv-black-star-promo-ecarlate-et-violet',
        '#collection-tempete-argentee-eb12',
        '#collection-eb11-epee-et-bouclier-origine-perdue',
        '#collection-eb10-epee-et-bouclier-astres-radieux',
        '#collection-eb09-epee-et-bouclier-stars-etincelantes',
        '#collection-eb08-epee-et-bouclier-poing-de-fusion',
        '#collection-eb07-5-epee-et-bouclier-celebrations',
        '#collection-eb07-epee-et-bouclier-evolution-celeste',
        '#collection-epee-et-bouclier-regne-de-glace-eb06',
        '#collection-eb05-epee-et-bouclier-styles-de-combat',
        '#collection-eb04-5-epee-et-bouclier-destinees-radieuses',
        '#collection-eb04-epee-et-bouclier-voltage-eclatant',
        '#collection-eb03-5-epee-et-bouclier-la-voie-du-maitre',
        '#collection-eb03-epee-et-bouclier-tenebres-embrasees',
        '#collection-eb02-epee-et-bouclier-clash-des-rebelles',
        '#collection-eb01-epee-et-bouclier',
        '#collection-black-star-promo-swsh',
        '#collection-la-rage-des-abysses-rota',
        '#collection-lumiere-de-la-destruction-lodt',
        '#collection-linfini-interdit-info',
        '#collection-batailles-de-legende-la-vengeance-du-terminal-bltr',
        '#collection-cauchemar-fantome-phni',
        '#collection-nexus-du-duelliste-dune',
        '#collection-batailles-de-legende-vengeance-cristal-blcr',
        '#collection-explosion-de-laile-des-tenebres-dabl',
        '#collection-les-maitres-tactiques-tama',
        '#collection-le-pouvoir-des-elements-pote',
        '#collection-duellistes-legendaires-duels-des-profondeurs-led9',
        '#collection-force-dimensionnelle-difo',
        '#collection-la-bataille-du-chaos-bach',
        '#collection-les-grands-createurs-grcr',
        '#collection-freres-de-legende-brol',
        '#collection-explosion-de-la-destinee-bode',
        '#collection-la-tempete-synchro-duellistes-legendaires-8-led8',
        '#collection-laube-de-la-majeste-dama-1',
        '#collection-la-cour-du-roi-kico',
        '#collection-foudre-amplifiee-liov',
        '#collection-les-anciens-gardiens-angu',
        '#collection-vortex-embrase-blvo',
        '#collection-impact-de-la-genese-geim',
        '#collection-rage-fantome-phra',
        '#collection-duellistes-legendaires-la-rage-de-ra-led7',
        '#collection-lascension-du-duelliste-rotd',
        '#collection-batailles-de-legendes-armageddon-blar',
        '#collection-le-chaos-toon-toch',
        '#collection-mega-tin-2024-boite-du-25eme-anniversaire-les-miroirs-du-duel-mp24',
        '#collection-mega-tin-2022-boite-des-dieux-du-pharaon-mp22',
        '#collection-tin-2021-boite-des-batailles-anciennes',
        '#collection-mega-tin-box-2020-memoires-perdues',
        '#collection-deck-de-structure-lassaut-dalbaz-sdaz',
        '#collection-deck-de-structure-assaut-cyber-sdcs',
        '#collection-deck-des-dieux-egyptiens-slifer-le-dragon-celeste-egs1',
        '#collection-deck-des-dieux-egyptiens-obelisk-le-tourmenteur-ego1',
        '#collection-deck-de-structure-les-chaines-glaciales-sdfc',
        '#collection-deck-de-structure-les-charmeuses-spirituelles-sdch',
        '#collection-deck-de-structure-les-betes-sacrees-sdsa',
        '#collection-batailles-de-legende-chapitre-1-blc1',
        '#collection-les-expertes-fantastiques-mama',
        '#collection-speed-duel-gx-le-paradoxe-des-partiels-sgx2',
        '#collection-duellistes-legendaires-saison-3-lds3',
        '#collection-fantomes-du-passe-2022-la-2e-incarnation-gfp2',
        '#collection-coffret-speed-duel-gx-duel-academy-sgx1',
        '#collection-coffret-arsenal-mysterieux-chapitre-1-hac1',
        '#collection-or-maximum-eldorado-mged',
        '#collection-decks-legendaires-de-yugi-ygld-reprint',
        '#collection-les-fantomes-du-passe-gftp',
        '#collection-duellistes-legendaires-saison-2-lds2-fr',
        '#collection-coffret-speed-duel-bataille-ville-sbcb',
        '#collection-or-maximum-mago',
        '#collection-les-dragons-de-legende-la-serie-complete-dlcs',
        '#collection-duellistes-legendaires-saison-1-lds1',
        '#collection-duel-surcharge-duov',
        '#collection-le-pouvoir-du-duel-dupo',
        '#collection-b17-uws-8-boost-ultimate-squad-bt17',
        '#collection-b16-boost-realm-of-the-gods-bt16',
        '#collection-boost-saiyan-showdown-b15-unison-warrior-series',
        '#collection-b12-uws-3-vicious-rejuvenation-bt12',
        '#collection-eb03-giant-force-expansion-booster-3-db3',
        '#collection-b11-vermilion-bloodline',
        '#collection-b10-rise-of-the-unison-warrior',
        '#collection-cartes-promotionnelles'
    ];
    
    [...document.querySelectorAll('[id*="collection-"]')]
        .filter(el => !ignored.includes(`#${el.id}`))
        .forEach((el, i) => el.style.setProperty('order', -1000 - i, 'important'));
});
// Générateur de couleurs automatique pour les sections avec couleurs personnalisées
class SectionGradientGenerator {
  constructor() {
    this.usedHues = new Set();
    this.customColors = ['#e67e22', '#520f27', '#169e8c']; // Vos couleurs personnalisées
    this.predefinedGradients = {
      'ecarlate-et-violet': 'linear-gradient(90deg, #e67e22 25%, #520f27 75%)',
      'epee-et-bouclier': 'linear-gradient(90deg, #520f27 25%, #169e8c 75%)'
    };
  }

  // Convertit une couleur hex en rgba
  hexToRgba(hex, alpha = 1) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Crée des variations d'une couleur hex
  createColorVariation(hexColor, lightnessDelta = 0, saturationDelta = 0) {
    // Convertit hex en HSL pour manipulation
    const r = parseInt(hexColor.slice(1, 3), 16) / 255;
    const g = parseInt(hexColor.slice(3, 5), 16) / 255;
    const b = parseInt(hexColor.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }

    // Applique les variations
    s = Math.max(0, Math.min(1, s + saturationDelta));
    l = Math.max(0, Math.min(1, l + lightnessDelta));
    h = h * 360;

    return this.hslToRgba(h, s * 100, l * 100);
  }

  // Convertit HSL en RGBA
  hslToRgba(hue, saturation, lightness, alpha = 1) {
    const s = saturation / 100;
    const l = lightness / 100;
    
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((hue / 60) % 2 - 1));
    const m = l - c / 2;
    
    let r, g, b;
    
    if (0 <= hue && hue < 60) {
      r = c; g = x; b = 0;
    } else if (60 <= hue && hue < 120) {
      r = x; g = c; b = 0;
    } else if (120 <= hue && hue < 180) {
      r = 0; g = c; b = x;
    } else if (180 <= hue && hue < 240) {
      r = 0; g = x; b = c;
    } else if (240 <= hue && hue < 300) {
      r = x; g = 0; b = c;
    } else {
      r = c; g = 0; b = x;
    }
    
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Génère un dégradé basé sur le nom de la section avec vos couleurs
  generateGradientFromName(sectionName) {
    // Utilise le hash du nom pour sélectionner les couleurs
    let hash = 0;
    for (let i = 0; i < sectionName.length; i++) {
      const char = sectionName.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    
    const colorIndex1 = Math.abs(hash) % this.customColors.length;
    const colorIndex2 = (colorIndex1 + 1) % this.customColors.length;
    
    const color1 = this.customColors[colorIndex1];
    const color2 = this.customColors[colorIndex2];
    
    // Différents types de dégradés avec vos couleurs
    const gradientTypes = [
      // Dégradé horizontal
      () => `linear-gradient(90deg, ${color1} 25%, ${color2} 75%)`,
      
      // Dégradé diagonal
      () => `linear-gradient(45deg, ${color1} 0%, ${color2} 100%)`,
      
      // Dégradé radial
      () => `radial-gradient(circle, ${color1} 30%, ${color2} 70%)`,
      
      // Dégradé avec trois couleurs
      () => {
        const color3 = this.customColors[(colorIndex2 + 1) % this.customColors.length];
        return `linear-gradient(90deg, ${color1} 0%, ${color2} 50%, ${color3} 100%)`;
      },
      
      // Dégradé avec variations de transparence
      () => {
        const color1Alpha = this.hexToRgba(color1, 0.9);
        const color2Alpha = this.hexToRgba(color2, 0.7);
        return `linear-gradient(135deg, ${color1Alpha} 25%, ${color2Alpha} 75%)`;
      }
    ];
    
    // Sélectionne un type de dégradé basé sur le hash
    const typeIndex = Math.abs(hash >> 8) % gradientTypes.length;
    return gradientTypes[typeIndex]();
  }

  // Génère ou récupère un dégradé pour une section
  getGradientForSection(sectionId) {
    // Utilise un dégradé prédéfini s'il existe
    if (this.predefinedGradients[sectionId]) {
      return this.predefinedGradients[sectionId];
    }
    
    // Sinon génère automatiquement avec vos couleurs
    return this.generateGradientFromName(sectionId);
  }

  // Applique les dégradés à toutes les sections trouvées
  applyGradientsToAllSections() {
    const sections = document.querySelectorAll('.series-section[id]');
    
    sections.forEach(section => {
      const sectionId = section.id;
      const gradient = this.getGradientForSection(sectionId);
      
      section.style.background = gradient;
      section.style.backgroundAttachment = 'fixed'; // Optionnel : effet parallaxe
      
      console.log(`✨ Dégradé appliqué à "${sectionId}":`, gradient);
    });
    
    console.log(`🎨 ${sections.length} sections stylisées avec vos couleurs personnalisées !`);
  }

  // Ajoute manuellement un dégradé personnalisé
  addCustomGradient(sectionId, gradient) {
    this.predefinedGradients[sectionId] = gradient;
    
    const section = document.getElementById(sectionId);
    if (section) {
      section.style.background = gradient;
      console.log(`🎯 Dégradé personnalisé ajouté pour "${sectionId}"`);
    }
  }

  // Génère tous les types de dégradés possibles avec vos couleurs
  generateAllPossibleGradients() {
    const gradients = [];
    const colors = this.customColors;
    
    // Toutes les combinaisons de 2 couleurs
    for (let i = 0; i < colors.length; i++) {
      for (let j = 0; j < colors.length; j++) {
        if (i !== j) {
          gradients.push({
            name: `gradient-${i}-${j}`,
            value: `linear-gradient(90deg, ${colors[i]} 25%, ${colors[j]} 75%)`
          });
        }
      }
    }
    
    return gradients;
  }
}

// Instance globale du générateur
const gradientGenerator = new SectionGradientGenerator();

// Fonction principale d'initialisation
function initializeSectionGradients() {
  gradientGenerator.applyGradientsToAllSections();
}

// Observer pour les nouvelles sections ajoutées dynamiquement
const sectionObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('series-section') && node.id) {
          const gradient = gradientGenerator.getGradientForSection(node.id);
          node.style.background = gradient;
          console.log(`🆕 Nouvelle section détectée et stylisée: "${node.id}"`);
        }
      });
    }
  });
});

// Démarre l'observation
sectionObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Initialisation automatique
document.addEventListener('DOMContentLoaded', initializeSectionGradients);

// Si le DOM est déjà chargé
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSectionGradients);
} else {
  initializeSectionGradients();
}

// API publique pour interactions manuelles
window.SectionGradients = {
  // Réapplique tous les dégradés
  refresh: () => gradientGenerator.applyGradientsToAllSections(),
  
  // Ajoute un dégradé personnalisé
  addCustom: (sectionId, gradient) => gradientGenerator.addCustomGradient(sectionId, gradient),
  
  // Génère un nouveau dégradé pour une section
  regenerate: (sectionId) => {
    delete gradientGenerator.predefinedGradients[sectionId];
    const section = document.getElementById(sectionId);
    if (section) {
      const newGradient = gradientGenerator.generateGradientFromName(sectionId + Date.now());
      section.style.background = newGradient;
      console.log(`🔄 Dégradé régénéré pour "${sectionId}":`, newGradient);
    }
  },
  
  // Affiche tous les dégradés possibles avec vos couleurs
  showAllGradients: () => {
    const allGradients = gradientGenerator.generateAllPossibleGradients();
    console.log('🎨 Tous les dégradés possibles avec vos couleurs:', allGradients);
    return allGradients;
  },
  
  // Applique un dégradé spécifique par index
  applyGradientByIndex: (sectionId, gradientIndex) => {
    const allGradients = gradientGenerator.generateAllPossibleGradients();
    if (gradientIndex < allGradients.length) {
      const gradient = allGradients[gradientIndex].value;
      gradientGenerator.addCustomGradient(sectionId, gradient);
    }
  }
};

console.log('🌈 Générateur de dégradés avec vos couleurs personnalisées initialisé !');
console.log('🎨 Couleurs utilisées:', gradientGenerator.customColors);